import React, { forwardRef } from "react";
import { List, ListProps } from "../List/List";
import { Paper, PaperProps } from "../Paper";

export interface MenuListProps extends ListProps {
  /**
   * 内部的に使われているPaperコンポーネントに渡すPropsを指定します。
   */
  paperProps?: PaperProps;
}

export const MenuList = forwardRef(
  ({ children, paperProps, ...props }, ref) => {
    return (
      <Paper {...paperProps}>
        <List {...props} ref={ref}>
          {children}
        </List>
      </Paper>
    );
  },
) as React.ForwardRefExoticComponent<MenuListProps>;
